export const RobotFace = ({ size = 22, talking }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" className={`robot-face ${talking ? 'talk' : ''}`}>
    <line x1="16" y1="2.5" x2="16" y2="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <circle cx="16" cy="2.5" r="2" fill="#f97316" />
    <rect x="5" y="7" width="22" height="18" rx="6" fill="currentColor" />
    <rect x="2" y="13" width="3" height="7" rx="1.5" fill="currentColor" /><rect x="27" y="13" width="3" height="7" rx="1.5" fill="currentColor" />
    <circle className="rf-eye" cx="11.5" cy="15" r="2.6" fill="#22d3ee" /><circle className="rf-eye" cx="20.5" cy="15" r="2.6" fill="#22d3ee" />
    <rect className="rf-mouth" x="11" y="20" width="10" height="2.4" rx="1.2" fill="#22d3ee" />
  </svg>
);
